import { Button, DatePicker, Form, Input, InputNumber, Select, message } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  FilterPayload,
  getPaymentList,
  getSelectList,
  SelectList,
  SelectPayload,
  SelectResponse,
} from 'api/dashboard';

import { FileExcelFilled } from '@ant-design/icons';
import PaymentList from '../PaymentList';
import { handleOnlyNumber } from 'features/nach/utils/handleOnlyNumber';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
const dateFormat = 'DD/MM/YYYY';

type Props = {
  isLoading: boolean;
  onSubmit: (values: FilterPayload) => Promise<void>;
};

const filterPayload: FilterPayload = {};
const initPartners: SelectList[] = [];
const initSelectResp: SelectResponse = {
  data: [],
};
const Filter = ({ onSubmit }: Props) => {
  const { Option } = Select;

  const [form] = Form.useForm<FilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [statusList, setStatus] = useState(initPartners);
  const [statusId, setStatusId] = useState(0);
  const [_sourceId, setSourceId] = useState(0);
  const [sources, setSource] = useState(initSelectResp);
  const [onlyDigitError, setOnlyDigitError] = useState(false);

  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'StatusSource',
    };
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });

    // setAdmin(adminRole);
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'Source',
      };
      // setIsLoading(false);
      getSelectList(sourcePayload).then((res) => {
        // setPagedList(res);
        //   setIsLoading(true);
        setSource(res);
      });
    }
  }, []);

  const handleStatusId = (e: any) => {
    form.setFieldValue('statusId', e);
    form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };
  function getFullDate(date: string) {
    if (date != null) {
      const dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
      return dateMoment;
    }
  }


  // RENAMED for clarity: formats DATE ONLY
  function formatDateOnly(date: string | null | undefined): string {
    if (date != null && date.trim() !== '') {
      return moment(new Date(date)).format('DD/MM/YYYY');
    }
    return '';
  }

  // ... (rest of your Filter.tsx code)
  const handleSubmit = useCallback(
    async (values: FilterPayload) => {
      debugger;
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      if (isAdmin != 'true') {
        updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
        updatedValues.pageNo = 1;
        updatedValues.pageSize = 10;
      }
      // updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      setFilter(updatedValues);
      // form.resetFields();
    },
    [onSubmit, form]
  );

  function handleDownload(_e: any) {
    const filterValues: FilterPayload = form.getFieldsValue();
    filterValues.Username = sessionStorage.getItem('user')?.toString();
    filterValues.userId = sessionStorage.getItem('userId')?.toString();
    filterValues.roleId = sessionStorage.getItem('roleId')?.toString();

    console.log("Payment Dashboard - Report123 " + filterValues.Username + "  " + filterValues.userId + "  " + filterValues.roleId)
    const fromDate = filterValues.PaymentDateFrom;
    const toDate = filterValues.To;

    if (!fromDate || !toDate) {
      message.destroy();
      message.warning('Please Select From Date and To Date Within Range of 30 Days');
      return;
    }

    const diffDays = moment(toDate).diff(moment(fromDate), 'days');

    if (diffDays < 0) {
      message.destroy();
      message.warning('"To" date should be after "From" date.');
      return;
    }

    if (diffDays > 30) {
      message.destroy();
      message.warning('Please Select From Date and To Date Within Range of 30 Days');
      return;
    }

    filterValues.IsExtract = true;

    if (isAdmin != 'true') {
      filterValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    debugger;
    // getPaymentList(filterValues).then((_x) => {
    //   const dashboardData = _x.data.data;
    //   debugger;
    //   if (dashboardData.length <= 0) {
    //     message.info('No Result Extrated');
    //   }
    //   const csvConfig = mkConfig({
    //     useKeysAsHeaders: true,
    //     filename: 'Payment Dashboard - Report',
    //   });
    //   const csv = generateCsv(csvConfig)(dashboardData);
    //   download(csvConfig)(csv);
    // });

    getPaymentList(filterValues).then((_x) => {
      let settings = {
        fileName: 'Payment Dashboard - Report',
        extraLength: 3,
        writeMode: 'writeFile',
        writeOptions: {},
        RTL: false,
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index: number) => ({
        ...item,
        RequestDate: getFullDate(item.PAYMENTREQUESTDATETIME),
        VALUEDATE: getFullDate(item.VALUEDATE),
        ROWNUM: index + 1,
        FORECLOSURE_REQUEST_DATE_XL: formatDateOnly(item.foreclosureRequestDate),
        FORECLOSURE_ISSUANCE_DATE_XL: formatDateOnly(item.foreclosureIssuanceDate),
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'LAN Number', value: 'LANUMBER' },
            { label: 'Verification Reason', value: 'VERIFICATIONREASON' },
            { label: 'Agent Reject Remarks', value: 'AGENTREJECTREMARKS' },
            { label: 'Request Purpose', value: 'REQUESTPURPOSE' },
            { label: 'Source Application Name', value: 'SOURCEAPPLICATIONNAME' },
            { label: 'Payment Request Id', value: 'PAYMENTREQUESTID' },
            { label: 'Loan Type', value: 'LOANTYPE' },
            { label: 'Amount', value: 'AMOUNT' },
            { label: 'Request Status', value: 'RequestStatus' },
            { label: 'New Status', value: 'NEW_STATUS' },
            { label: 'Currency', value: 'CURRENCY' },
            { label: 'Session Id', value: 'SESSIONID' },
            { label: 'Payment Purpose', value: 'PAYMENTPURPOSE' },
            { label: 'Merchent Id', value: 'MERCHANTID' },
            { label: 'Payment Request Date and Time', value: 'RequestDate' },
            { label: 'Mode', value: 'MODE' },
            { label: 'Impact Mode', value: 'IMPACTMODE' },
            { label: 'Gateway Name', value: 'GATEWAYNAME' },
            { label: 'Ref Transection', value: 'REFTRANSACTION' },
            { label: 'Payment Ref', value: 'PAYMENTREF' },
            { label: 'Bank Code', value: 'BANKCODE' },
            { label: 'Value Date', value: 'VALUEDATE' },
            { label: 'Pennant Receipt Date & Time', value: 'PENNANTRECEIPTDATE' },
            { label: 'Favour Name', value: 'FAVOURNAME' },
            { label: 'Remarks', value: 'REMARKS' },
            { label: 'Razorpay Order Id', value: 'RAZORPAY_ORDER_ID' },
            { label: 'Razorpay Payment Id', value: 'RAZORPAY_PAYMENT_ID' },
            { label: 'Funding Account', value: 'FUNDINGACCOUNT' },
            { label: 'Pennant Receipt number', value: 'PENNANTRECEIPTNO' },
            { label: 'Pennant Error Description', value: 'PENNANTERRORDESC' },
            { label: 'Auth Code', value: 'AUTH_CODE' },
            { label: 'Payment Request Error ', value: 'PAYMENTREQUESTERROR' },
            { label: 'Webhook Error ', value: 'WEBHOOKERROR' },
            { label: 'Account Id', value: 'ACCOUNT_ID' },
            { label: 'Foreclosure Request Date', value: 'FORECLOSURE_REQUEST_DATE_XL' },
            { label: 'Foreclosure Issuance Date', value: 'FORECLOSURE_ISSUANCE_DATE_XL' },
            { label: 'By Agent', value: 'BYAGENT' },


          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  // function handleDate(_e: any) {
  //   filter.PaymentDateFrom = moment(_e, 'DD/MM/YYYY').toString();
  // }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }

  const memoizedFilter = useMemo(() => filter, [filter]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Payment Dashboard</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<FilterPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['SourceApplicationName']:
                      isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Number :'} name="LANumber" className="fieldTitle">
                          <Input placeholder={'Loan Number'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Order ID :'} name="OrderId" className="fieldTitle">
                          <Input placeholder={'Order ID'} />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Status :'} name="Status" className="fieldTitle">
                          <Select
                            placeholder="Select"
                            size="large"
                            value={statusId.toString()}
                            onSelect={handleStatusId}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose :'}
                          name="PaymentPurpose"
                          className="fieldTitle"
                        >
                          {/* <InputNumber placeholder={'Payment Purpose'} /> */}
                          <Select placeholder="Select" size="large">
                            <Option value="Fees">Fees</Option>
                            <Option value="Foreclosure">Foreclosure</Option>
                            <Option value="Overdue">Overdue</Option>
                            <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                            <Option value="PartPayment">PartPayment</Option>
                            <Option value="ADVANCEEMI">Advance EMI</Option>
                            <Option value="OtherCharges">Other Charges</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Request Purpose:'}
                          name="RequestPurpose"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" size="large">
                            <Option value="Payment">Payment</Option>
                            <Option value="Receipt">Receipt</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Payment ID:'} name="PaymentId" className="fieldTitle">
                          <Input placeholder={'Payment ID'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Date From:'}
                          name="PaymentDateFrom"
                          className="fieldTitle"
                        >
                          <DatePicker format={dateFormat} />
                          {/* <DatePicker format={'DD/MM/YYYY'} onSelect={handleDate} /> */}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'To :'} name="To" className="fieldTitle">
                          <DatePicker format={dateFormat} />
                          {/* <DatePicker format={'DD-MM-YYYY'} onSelect={handleDate} /> */}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        {isAdmin == 'true' ? (
                          <Form.Item
                            label={'Source Application Name :'}
                            name="SourceApplicationName"
                            className="fieldTitle"
                          >
                            <Select
                              placeholder="Select"
                              size="large"
                              value={statusId.toString()}
                              onSelect={handleSourceId}
                            >
                              {/* <Option value="0">Select</Option> */}
                              {sources.data.map((role) => (
                                <Option value={role.SText}>{role.SText}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        ) : (
                          <Form.Item
                            label={'Source Application Name :'}
                            name="SourceApplicationName"
                            className="fieldTitle"
                          >
                            <Input
                              disabled={true}
                              style={{
                                border: '1px solid #dcdcdc',
                                borderRadius: '4px',
                                fontWeight: '600',
                                background: '#fafbfa',
                                opacity: 0.5,
                              }}
                            />
                          </Form.Item>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Merchant ID :'} name="MerchantId" className="fieldTitle">
                          <Input placeholder={'Merchant ID'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Reference No :'}
                          name="PaymentRefNo"
                          className="fieldTitle"
                        >
                          <Input placeholder={'Payment Reference No'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Request ID :'}
                          name="PaymentRequestId"
                          className="fieldTitle"
                          validateStatus={onlyDigitError ? 'error' : ''}
                          help={onlyDigitError ? 'Only numbers are allowed' : ''}
                        >
                          <InputNumber
                            value={form.getFieldValue('PaymentRequestId')}
                            onBeforeInput={(e) => handleOnlyNumber(e, setOnlyDigitError)}
                            placeholder={'Payment Request ID:'}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Gateway Name :'}
                          name="gatewayname"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" size="large">
                            <Option value="Phonepe">Phonepe</Option>
                            <Option value="RazorPay">RazorPay</Option>
                            <Option value="NA">NA</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <Button
                      type="link"
                      icon={<FileExcelFilled />}
                      style={{ float: 'right', fontSize: '30px', color: 'green' }}
                      onClick={handleDownload}
                    ></Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      onClick={handleReset}
                      style={{ float: 'right', marginRight: '5px' }}
                    >
                      {'CLEAR'}
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ float: 'right', marginRight: '10px' }}
                    >
                      {'SEARCH'}
                    </Button>
                    &nbsp; &nbsp;
                  </div>
                </Form>
              </div>
              <PaymentList
                filter={memoizedFilter}
                onSubmit={handleSubmit}
                setOnlyDigitError={setOnlyDigitError}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;